/**
 * Sidebar Visibility Context
 * Allows child components to control sidebar visibility
 */

import { createContext, useContext, useState, ReactNode } from 'react'

interface SidebarVisibilityContextType {
  hideSidebar: boolean
  setHideSidebar: (hide: boolean) => void
}

const SidebarVisibilityContext = createContext<SidebarVisibilityContextType | undefined>(undefined)

export function SidebarVisibilityProvider({ children }: { children: ReactNode }) {
  const [hideSidebar, setHideSidebar] = useState(false)

  return (
    <SidebarVisibilityContext.Provider value={{ hideSidebar, setHideSidebar }}>
      {children}
    </SidebarVisibilityContext.Provider>
  )
}

export function useSidebarVisibility() {
  const context = useContext(SidebarVisibilityContext)
  // Return default values if context is not available (for backwards compatibility)
  if (context === undefined) {
    return { hideSidebar: false, setHideSidebar: () => {} }
  }
  return context
}

